import React from 'react';
import { Box, SkeletonGroup, SkeletonRectangle } from '@wix/design-system';
import s from './horizontal-nav-bar-skeleton.module.scss';

const pillsCount = 8;

export function HorizontalNavBarSkeleton() {
  return (
    <SkeletonGroup skin="light">
      <Box className={s.skeletonBar}>
        <Box className={s.pills}>
          {Array.from({ length: pillsCount }, (_, index) => (
            <Box key={index} className={s.pill}>
              <SkeletonRectangle width="120px" height="30px" />
            </Box>
          ))}
        </Box>
        <Box className={s.search}>
          <SkeletonRectangle width="213px" height="30px" />
        </Box>
      </Box>
    </SkeletonGroup>
  );
}
